import { apiCall, baseUrl, extendUrl } from './config';
import { parseQueryParams } from '../../utils/queryParams';
import { shouldUseMock } from '../../utils/common';
import {
  favoriteNodeActionMock, getSelectionMock, getSelectionDetailMock, setCommentsMock, getCategoriesMock
} from './mock';

export default {
  getMandatoryTrainingList: (filters) => {
    if (shouldUseMock()) {
      return getSelectionMock();
    }
    return apiCall(`${baseUrl}${extendUrl}user/course${parseQueryParams(filters)}`, 'GET');
  },
  getMandatoryTrainingDetails: ({ id, ...filters }) => {
    if (shouldUseMock()) {
      return getSelectionDetailMock();
    }
    return apiCall(`${baseUrl}${extendUrl}user/course/${id}/details${parseQueryParams(filters)}`, 'GET');
  },
  setNodeAction: (payload) => {
    if (shouldUseMock()) {
      return favoriteNodeActionMock();
    }
    return apiCall(`${baseUrl}${extendUrl}user/node_action`, 'POST', payload);
  },
  setComment: (body) => {
    if (shouldUseMock()) {
      return setCommentsMock();
    }
    return apiCall('/comment', 'POST', body);
  },
  getCategories: (filters) => {
    if (shouldUseMock()) {
      return getCategoriesMock();
    }
    return apiCall(`${baseUrl}${extendUrl}vocabulary${parseQueryParams(filters)}`, 'GET');
  }
};
